import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import './forgot.css'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Col } from 'reactstrap'
import Loader from '../../components/Loader'
import { invalidOTP, emptyOtp } from '../../utilities/message'
import OtpInput from 'react-otp-input'
import { useTimer } from 'react-timer-hook'
import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { verifyOtp, forgotPassword } from '../../actions/user'
import { Modal } from '@mui/material'

const OtpTimer = ({ history }) => {
    const loaders = useSelector((state) => state.loader)
    const [openModal, setModal] = useState(true)
    const [otp, setOtp] = useState(null)
    const [error, setError] = useState(false)
    const user = useSelector((state) => state.user)
    const dispatch = useDispatch()
    const [errorMsg, setErrorMsg] = useState('')
    const [resendDisabled, setResendDisabled] = useState(true)
    

    //*************timer */
    const expiryTimestamp = new Date()
    expiryTimestamp.setSeconds(expiryTimestamp.getSeconds() + 180) // 2 minutes timer
    const {
        seconds,
        minutes,
       
        restart,
    } = useTimer({
        expiryTimestamp,
        autoStart: true,
        onExpire: () => setResendDisabled(false),
    })

    useEffect(() => {
        if (error && otp && otp.length != 4) {
            setError(true)
        } else {
            setError(false)
        }
    }, [otp])

    //***********MODAL******************* */
    const handleModal = () => {
        setModal(!openModal)
    }
    const closepopup = () => {
        setModal(!openModal)
    }
    const styleDeletePopup = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 366,
        borderRadius: 10,
        bgcolor: 'background.paper',
        pt: 2,
        px: 4,
        pb: 3,
    }

    const resendOtp = () => {
        dispatch(
            forgotPassword({ email: user.forgot_email }, (res) => {
                if (res) {
                    setResendDisabled(true)
                    setErrorMsg('')
                    setError(false)
                    setOtp(null)
                    const time = new Date()
                    time.setSeconds(time.getSeconds() + 180)
                    restart(time)
                }
            }),
        )
    }

    const submit = () => {
        if (otp == null || otp === '') {
            setError(true)
            setErrorMsg(emptyOtp)
        } else if (otp != null && otp.length < 4) {
            setError(true)
            setErrorMsg(invalidOTP)
        } else {
            dispatch(
                verifyOtp({ email: user.forgot_email, otp: otp }, (res) => {
                    if (res) {
                        history.push('/changePassword')
                    }
                }),
            )
            setError(false)
        }
    }

    return (
        <React.Fragment>
            <div>
                <Loader loading={loaders.isFetching} />
                <div className="forgotHeader">
                    <div className="logo-details">
                        <div onClick={()=>history.push('/dashboard')} className="logo2">
                            <img alt="logo" height={120} src={require('../../assets/images/newfile/Property 1=Variant2 (1).svg').default} />
                        </div>
                    </div>
                </div>
                <div className="forgotDiv">
                    <Box className="forgotPopup">
                        <div className="forgoticonshadow">
                            <i className=" timericon">
                                <div className="timerText">
                                    <span>{0 + '' + minutes}</span>:
                                    <span>
                                        {seconds.toString().length === 2
                                            ? seconds
                                            : 0 + '' + seconds}
                                    </span>
                                </div>
                            </i>
                        </div>
                        <div className="textForgotPopup">
                            <Typography id="modal-modal-title" variant="h6" component="h2">
                                Enter OTP
                            </Typography>
                            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                4-Digit code sent to{' '}
                                <span className="emailtoeidt">{user.forgot_email}</span>{' '}
                                <a>
                                    <i
                                        onClick={() => history.push('/forgotPassword')}
                                        class="otpediticon"
                                    >
                                        <img
                                            style={{ marginTop: '10px' }}
                                            src={require('../../assets/images/Edit.png')}
                                        />
                                    </i>
                                </a>
                            </Typography>

                            <Typography>
                                <OtpInput
                                    value={otp}
                                    onChange={setOtp}
                                    numInputs={4}
                                    inputStyle="inputstyle"
                                    containerStyle="otpstyle"
                                    inputType="number"
                                    renderInput={(props) => <input {...props} />}
                                />
                                {error && <p style={{ color: 'red' }}>{errorMsg}</p>}
                                <Col sm="12 form-button-spacing">
                                    <button
                                        type="submit"
                                        onClick={() => submit()}
                                        className="btn btn-primary btn-block "
                                    >
                                        Verify OTP
                                    </button>
                                </Col>
                                <Col sm="12 form-button-spacing">
                                    <button
                                        onClick={() => resendOtp()}
                                        disabled={resendDisabled}
                                        className={
                                            resendDisabled
                                                ? 'disablebutton resendButton'
                                                : 'resendButton'
                                        }
                                    >
                                        Resend
                                    </button>
                                </Col>
                                <Link to="/">
                                    <Col sm="12 form-button-spacing backlogin">
                                        <p>
                                            <img src={require('../../assets/images/back.png')} />
                                        </p>
                                        <p>Back to login</p>
                                    </Col>
                                </Link>
                            </Typography>
                        </div>
                    </Box>
                </div>
            </div>
            <Modal
                open={openModal}
                onClose={handleModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleDeletePopup} className="deletePopup">
                    <div className="iconshadow">
                        <i className=" congratulationsForgot">
                            <button>
                                <img src={require('../../assets/images/congrates.png')} />
                            </button>
                        </i>
                    </div>
                    <div className="textDeletePopup">
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            Check your email
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            We have sent password recovery instructions to your email.
                        </Typography>

                        <Typography>
                            <div className="buttonGroupDelete">
                                <button
                                    className="btn btn-primary btn-block okaybutton"
                                    onClick={() => closepopup()}
                                >
                                    Okay
                                </button>
                            </div>
                        </Typography>
                    </div>
                </Box>
            </Modal>
        </React.Fragment>
    )
}

export default OtpTimer
